import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Description, List, ListEl, Note, Title } from './elements'

export const Gmail = () => {
  return (
    <>
      <Title>{i18n.t('app_store_v2.integrations.gmail.description_view.title_1')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.gmail.description_view.description_1')}
      </Description>
      <Title>{i18n.t('app_store_v2.integrations.gmail.description_view.title_2')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.gmail.description_view.description_2')}
      </Description>
      <List>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.1')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.2')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.3')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.4')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.5')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.6')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.7')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.8')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.9')}</ListEl>
        <Note>
          {i18n.tView('app_store_v2.integrations.gmail.description_view.note_1', {
            note: (
              <Text size="300" weight="medium">
                {i18n.t('common.note')}
              </Text>
            ),
          })}
        </Note>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.10')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.11')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.gmail.description_view.list_1.12')}</ListEl>
      </List>
      <Description>
        {i18n.t('app_store_v2.integrations.gmail.description_view.description_3')}
      </Description>
    </>
  )
}
